import React from 'react';
import { componentService } from 'js/services/component.service';

export const LogoutButton = React.lazy(() => import(/* webpackChunkName: "logout-button" */ './LogoutButton'));
// Buzz override: uncomment register as webcontent (line 2, 6)
componentService.registerWebContentComponents({ Logout: LogoutButton });
